"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
const IUserAuthenticationService_interface_1 = require("../interfaces/IUserAuthenticationService.interface");
const AuthAction_1 = require("../interfaces/AuthAction");
const Subject_1 = require("rxjs/Subject");
let UserAuthStateService = class UserAuthStateService {
    constructor(_userAuthenticationService) {
        this._userAuthenticationService = _userAuthenticationService;
        this.username = "";
        this.level = "";
        this._actionRequest = new Subject_1.Subject();
        this.level = this._userAuthenticationService.InvalidUserLevel;
    }
    login(loginResult) {
        return this.doLogin(this._userAuthenticationService.InvalidUserLevel, loginResult);
    }
    logout() {
        console.log("User " + this.username + " logged out.");
        this.username = "";
        this.level = this._userAuthenticationService.InvalidUserLevel;
    }
    checkRequestedLevel(levelRequested, loginResult) {
        if (this._userAuthenticationService.isSufficientLevel(this.level, levelRequested)) {
            loginResult(this.username, this.level, true);
        }
        else {
            this.doLogin(levelRequested, loginResult);
        }
    }
    doLogin(levelRequested, loginResult) {
        this._actionRequest.next(new AuthAction_1.AuthAction("login", this._userAuthenticationService, (username, level, success) => {
            if (success && (levelRequested === this._userAuthenticationService.InvalidUserLevel
                || this._userAuthenticationService.isSufficientLevel(level, levelRequested))) {
                this.username = username;
                this.level = level;
            }
            else {
                success = false;
            }
            loginResult(this.username, this.level, success);
        }));
    }
    actionRequest() {
        return this._actionRequest;
    }
};
UserAuthStateService = __decorate([
    core_1.Injectable(),
    __param(0, core_1.Inject(IUserAuthenticationService_interface_1.IUSERAUTHENTICATIONSERVICE_TOKEN)),
    __metadata("design:paramtypes", [Object])
], UserAuthStateService);
exports.UserAuthStateService = UserAuthStateService;
